import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { MusicPracticeRoomStyled } from "./styled";
import { useTranslation } from "react-i18next";

const MusicPracticeRoom = ({
  theme_standard,
  banner_img,
  description_en,
  description_th,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { i18n } = useTranslation(["common"]);
  return (
    <MusicPracticeRoomStyled className={customClass}>
      <img
        className="musicroom_img"
        src={banner_img || "/assets/images/mockups/MusicPracticeRoom.jpg"}
        alt="music practice room"
      />
      <div className="musicroom_text">
        {i18n.language === "en" ? description_en : description_th}
      </div>
    </MusicPracticeRoomStyled>
  );
};

MusicPracticeRoom.propTypes = {};

export default MusicPracticeRoom;
